export default __webpack_public_path__ + "static/media/LogoMotivosSpa.03819a96.svg";